module.exports = __webpack_public_path__ + "static/media/li-line.feb5ed72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/li-line.svg
// module id = 1098
// module chunks = 0